"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIELD_MAP = new Map([
    ['availablefromurl', 'URL'],
    ['bookname', 'title'],
    ['booktitle', 'title'],
    ['chapter', 'chapter-number'],
    ['edition', 'edition'],
    ['fulljournalname', 'container-title'],
    ['issn', 'ISSN'],
    ['issue', 'issue'],
    ['medium', 'medium'],
    ['nlmuniqueid', 'id'],
    ['pages', 'page'],
    ['publisherlocation', 'publisher-place'],
    ['publishername', 'publisher'],
    ['reportnumber', 'number'],
    ['title', 'title'],
    ['volume', 'volume'],
]);
